import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as CloseSVG } from 'Images/icon-close-without-background.svg';
import { ReactComponent as ArrowExpandedSVG } from 'Images/wf_arrow_expand.svg';
import { ReactComponent as ArrowCollapsedSVG } from 'Images/wf_arrow_collapsed.svg';

export const Wrapper = styled.div`
  ${({ isShowingBody }) => !isShowingBody && 'border-radius: 5px'};
  ${({ isShowingBody }) => isShowingBody && 'border-top-left-radius: 5px'};
  ${({ isShowingBody }) => isShowingBody && 'border-top-right-radius: 5px'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: ${colors.blueGrey};
  height: 45px;
  padding-left: 25px;
  padding-right: 25px;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;
Wrapper.displayName = 'Wrapper';

export const HeaderMessage = styled.div`
  flex: 1 1 0px;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
HeaderMessage.displayName = 'HeaderMessage';

export const Close = styled(CloseSVG)`
  flex: 0 0 30px;
  height: 30px;
  cursor: pointer;
  margin: auto 0px auto auto;
  
  &:hover {
    background-color: ${colors.grey27} !important;
    border-radius: 50%;
  }
  path {
    fill: #fff;
  }
`;
Close.displayName = 'Close';

export const ArrowExpanded = styled(ArrowExpandedSVG)`
  padding: 5px;
  flex: 0 0 30px;
  height: 30px;
  cursor: pointer;
  margin: auto 0px auto auto;
  
  &:hover {
    background-color: ${colors.grey27} !important;
    border-radius: 50%;
  }
  path {
    fill: #fff;
  }
`;
ArrowExpanded.displayName = 'ArrowExpanded';

export const ArrowCollapsed = styled(ArrowCollapsedSVG)`
  padding: 5px;
  flex: 0 0 30px;
  height: 30px;
  cursor: pointer;
  margin: auto 0px auto auto;
  
  &:hover {
    background-color: ${colors.grey27} !important;
    border-radius: 50%;
  }
  path {
    fill: #fff;
  }
`;
ArrowCollapsed.displayName = 'ArrowCollapsed';
